<template>
  <b-modal ref="modal" hide-footer title="Email Document" id="emailDocument">
    <b-row class="my-1">
      <b-col md="3">
        <label for="vendor">Vendor</label>
      </b-col>
      <b-col md="9">
        <b-select
          placeholder="Please select"
          value-field="id"
          text-field="fullName"
          :options="vendors"
          v-model="selectedVendorId"
          @change="selectAddresses"
        ></b-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
        <label for="emailkAddress">Email Address</label>
      </b-col>
      <b-col md="9">
        <b-select
          placeholder="No vendor selected"
          value-field="emailType"
          text-field="emailAddressText"
          :options="addresses"
          v-model="selectedEmailType"          
        ></b-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="9">
        <b-button type="reset" variant="danger" @click="hideModal">
          <font-awesome-icon icon="times" /> Close
        </b-button>
        &nbsp;
        <b-button type="submit" variant="success" class="margin-right" :disabled="selectedEmailType == null" @click="send">
          <font-awesome-icon icon="check" /> Send
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
  components: { },
  props: { companyId: Number, documentId: Number, isDirector: Boolean },
  data() {
    return {
      vendors: [],
      addresses: [],
      selectedVendorId: null,
      selectedEmailType: null
    };
  },
  watch: {
    isDirector: function() {
      this.loadEmailAddresses();
    }
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();      
    },
    hideModal() {      
      this.selectedVendorId = null;
      this.selectedEmailType = null;
      this.$refs["modal"].hide();
    },
    loadEmailAddresses() {      
      this.$http.get('companynotes/' + this.$props.companyId + '/emailcontacts').then((response) => {        
        var addresses = [];
        var isDirector = this.$props.isDirector;
        response.data.forEach(function(recip) {   
          if(!isDirector || (isDirector && recip.isDirector)) {
            addresses.push({
              id: recip.id,
              fullName: recip.fullname,
              emailAddress: recip.emailAddress,
              emailAddressAlternative: recip.emailAddressAlternative
            });
          }
        });
        this.vendors = addresses;
      })
    },
    selectAddresses() {
      this.selectedEmailTypes = null;
      var addresses = [];
      var selectedVendorId = this.selectedVendorId;
      this.vendors.forEach(function(vendor) {
        if (vendor.id == selectedVendorId) {
          if (vendor.emailAddress != null) {
            addresses.push({ emailType: 1, emailAddressText: vendor.emailAddress + ' (Main)' });
          }
          if (vendor.emailAddressAlternative != null) {
            addresses.push({ emailType: 2, emailAddressText: vendor.emailAddressAlternative + ' (Alt)' });
          }
        }
      });
      this.addresses = addresses;
    },
    send() {
      this.$http.post('companydocument/email', { documentId: this.$props.documentId, vendorId: this.selectedVendorId, emailType: this.selectedEmailType, toClient: (this.$props.isDirector == false) }).then((response) => {
        if (response.status == 200) {
          this.hideModal();
        }
      });
    },
    addTag (newTag) {
      this.form.recipients.push(newTag)
    }
  },
};
</script>

<style scoped>
</style>
